export default __webpack_public_path__ + "static/projects-9994a6067a7bfae9292633415c47b3eb.png";